import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  bitcoin,
  cashApp,
  paypal,
  venmo,
  zelle,
} from "../../../../public/assets";
import { selectLocale } from "../../../locales/localeSlice";
import SectionTitle from "../General/SectionTitle";
import ServiceBubble from "../General/ServiceBubble/ServiceBubble";

import {
  Bitcoin,
  CashApp,
  IconsHolder,
  PaymentMethodContainer,
  Paypal,
  Venmo,
  Zelle,
} from "./PaymentMethod.styles";

const PaymentMethod = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <PaymentMethodContainer>
      <ServiceBubble
        position="center"
        label={t("paymentMethodSection.title", {
          lng: currentLocale,
        })}
        backgroundColor="rgba(0, 199, 3, 0.1)"
      />
      <SectionTitle
        label={t("paymentMethodSection.subTitle", {
          lng: currentLocale,
        })}
      />
      <IconsHolder>
        <Paypal src="/assets/icons/paypal.png" />
        <CashApp src="/assets/icons/cash-app.png" />
        <Zelle src="/assets/icons/zelle.png" />
        <Bitcoin src="/assets/icons/bitcoin.png" />
        <Venmo src="/assets/icons/216780_venmo_icon.png" />
      </IconsHolder>
    </PaymentMethodContainer>
  );
};

export default PaymentMethod;
